export default "__VITE_ASSET__fba89082__"